export const formatFieldsWithComma = (values, fields) => {
    if (!fields) {
        return values;
    }

    const data = fields.map((field) => Object.entries(values)
        .filter(([key]) => key === field)
        .map(([key, value]) => [key, value ? String(value).replace(',', '.') : value])
    ).flat();

    return { ...values, ...Object.fromEntries(data) };
};
